import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { OnlinePaymentTransactionStatusModel } from 'src/app/model/OnlinePaymentTransactionStatusModel';

@Component({
  selector: 'app-secure-default-password-modal',
  templateUrl: './default-password-modal.component.html',
  styleUrls: ['./default-password-modal.component.scss']
})
export class DefaultPasswordModalComponent implements OnInit {
  defaultPasswordForm: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void { 
    this.defaultPasswordForm = new FormGroup({
      password: new FormControl(null, [Validators.required, 
        Validators.pattern(/(?=.*\d)(?=.*[!`~@#$%^&*(){}[\]<>,.?/\\])(?=.*[a-z])(?=.*[A-Z]).{8,20}/), 
        Validators.minLength(8), Validators.maxLength(20)  
      ])
    });
  }

  onSubmit() {
    if (this.defaultPasswordForm.valid) {
      return this.modalCtrl.dismiss(this.defaultPasswordForm.value.password, 'submit');
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }

}
